import VocWatermark from "./src/main.vue"

/* istanbul ignore next */
VocWatermark.install = function (Vue) {
  Vue.component(VocWatermark.name, VocWatermark)
}

export default VocWatermark
